/* eslint-disable react/jsx-no-undef */
import React, { useState, useSelector } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { SearchCampaignHistory } from "../../services/LuckyDraw";
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import SecondaryButton from "../../components/button/SecondaryButton";
import InfiniteScroll from 'react-infinite-scroller';
import noPrize from '../../assets/images/no-prize.png';

export default function LuckyDrawHistory() {

    const initialLoadMore = {
        limit: 100,
        offset: 0,
    }

    const initialHistoryDataCount = 0

    const [loadMore, setLoadmore] = React.useState(initialLoadMore);
    const [isLoading, setIsLoading] = React.useState(true);
    const [historyDataCount, setHistoryDataCount] = React.useState(initialHistoryDataCount);
    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const [history, setHistory] = React.useState({
        condition: []
    });

    const [windowDimensions, setWindowDimensions] = React.useState(
        getWindowDimensions()
    );
    const { state } = useLocation();
    const { width } = windowDimensions;
    const navigate = useNavigate();

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    }

    React.useEffect(() => {
        getSearchCampaign(true)
    }, []);

    async function getSearchCampaign(isRender) {
        const { offset, limit } = loadMore
        return new Promise((resolve, reject) => {
            SearchCampaignHistory(lineId, {
                offset,
                limit,
                campaignId: state.campaignId
            }).then(async (response) => {
                let tmp = null
                if (+response.data.resultCode) {
                    console.log('response.data.body getScanData >>', response.data.body)
                    tmp = response.data.body
                }

                if (isRender) {
                    setHistory(tmp)
                    setHistoryDataCount(limit)
                }
            })
                .catch((error) => {
                    console.log(error);
                });
        })
    }


    React.useEffect(() => {
        console.log("width", width);
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    });


    function fnSetLoading(value) {
        let tmpObj = {};
        tmpObj.loading = value;
        // dispatch(setLoading(tmpObj));
    }

    const fetchItems = () => {
        if (historyDataCount) {
            // console.log('-----------------------------')
            // console.log('fetchItems!')
            onLoadMore()
            // console.log('-----------------------------')
        }
    }

    function onLoadMore() {
        console.log('loadMore A>>', loadMore.limit)
        console.log('loadMore B>>', history.length)
        if (history.length >= loadMore.limit) {
            setIsLoading(true)
            let tmp = { ...loadMore }
            tmp.offset = tmp.limit
            tmp.limit = tmp.limit + 1

            console.log('loadMore New >>', tmp)
            setLoadmore(tmp)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }

    const loader = (
        <div key="loader" className="loader text-center text-[20px] text-gray">
            Loading ...
        </div>
    );

    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: "#005AAA",
                    minHeight: "calc(100vh - 60px)",
                    paddingTop: "20px"
                }}
            >

                <div className="text-white text-center text-[24px] mb-[15px]">
                    ประวัติการลงทะเบียน / ตรวจสอบสถานะ
                </div>

                <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 250px)" }}>
                    <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    >
                        {Array.isArray(history) && history.length > 0 && history.map((item, index) => (
                            <div key={index}>
                                <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">
                                    <div className="grid" style={{ gridTemplateColumns: "4fr 2fr" }}>
                                        <div>
                                            <p className="text-darkGray text-[20px] leading-[19.2px] px-[16px]">{item.campaignName}</p>
                                        </div>
                                        {item.finalApprove === 'SUCCESS' ? (
                                            <div className="bg-green text-center rounded-[20px] h-[20px]">
                                                <p className="text-[14px] px-[16px]">ผ่านการตรวจสอบ</p>
                                            </div>
                                        ) : item.finalApprove === 'FAIL' ? (
                                            <div className="bg-lightRed text-center rounded-[20px] h-[20px]">
                                                <p className="text-[14px] px-[8px]">ไม่ผ่านการตรวจสอบ</p>
                                            </div>
                                        ) : (
                                            <div className="bg-yellow text-center rounded-[20px] h-[20px]">
                                                <p className="text-[14px] px-[8px]">กำลังตรวจสอบ</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="grid grid-cols-2">
                                        <div>
                                            <p className="text-darkGray text-[16px] leading-[20px] px-[16px]">ยื่นเมื่อวันที่: {dayjs(item.createDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                                            <p className="text-darkGray text-[16px] leading-[20px] px-[16px]">วันที่ออกใบเสร็จ: {dayjs(item.billDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-darkGray text-[16px] leading-[20px] pr-[16px]">จำนวนสิทธิ์ที่ได้รับ: {item.totalPoints}</p>
                                            <p className="text-darkGray text-[16px] leading-[20px] pr-[16px]">หมายเลขคำสั่งซื้อ: {item.billNo}</p>
                                        </div>
                                    </div>

                                    <div className="flex">
                                        <p className="text-darkGray text-[16px] leading-[19.2px] pl-[16px] mr-[3px] w-[84px]">รุ่นสินค้า:</p>
                                        <div>
                                            {Array.isArray(item.productList
                                            ) && item.productList
                                                .map(item2 => (
                                                    <p className="text-darkGray text-[16px] leading-[19.2px] pr-[16px]">{item2.name} {item2.code}</p>
                                                ))}
                                        </div>
                                    </div>


                                    <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[15px]" />
                                    {item.finalApprove === 'FAIL' &&
                                        <p className="whitespace-pre-line text-darkGray text-[16px] leading-[19.2px] px-[16px] my-[10px]">- {item.note}</p>
                                    }

                                    <SecondaryButton variant="outlined" className="w-full" onClick={() => navigate('/lucky-draw-history-detail',
                                        {
                                            state: item
                                        })}>
                                        รายละเอียด
                                    </SecondaryButton>
                                    <br></br>
                                </div>
                            </div>

                        ))}

                        {Array.isArray(history) && history.length === 0 &&
                            <div className="mt-[160px]">
                                <img className="mx-[24%] w-[65%] opacity-30" src={noPrize} alt="Snow" />
                                <div className="text-center">
                                    <p className="mx-auto text-[16px] text-white">
                                        ยังไม่มีการลงทะเบียน
                                    </p>
                                </div>
                            </div>
                        }
                    </InfiniteScroll>
                    {/* <hr className="border-b-1px border-lightGray w-full" /> */}
                    {/* <p className='py-[4px] text-center text-blue cursor-pointer' onClick={() => onLoadMore('event')}>โหลดเพิ่ม</p> */}
                </div>
            </div>
            <div className="bg-white w-full" style={{
                position: 'fixed',
                bottom: 0,
                padding: '20px'
            }}>
                <div className="place-content-center">
                    <SecondaryButton
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        <p>ย้อนกลับ</p>
                    </SecondaryButton>
                </div>

            </div>
        </>
    );
}
